import { Component, DestroyRef, EventEmitter, Input, OnInit, Output, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TopicListVisibleService } from '../../../home/services/topic-list-visible.service';

@Component({
  selector: 'customer-app-arrow-toggle-button',
  templateUrl: './arrow-toggle-button.component.html',
  styleUrls: ['./arrow-toggle-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ArrowToggleButtonComponent implements OnInit {
  private topicListVisible = inject(TopicListVisibleService);
  private destroyRef = inject(DestroyRef);

  // eslint-disable-next-line @angular-eslint/no-output-native
  @Output() toggle = new EventEmitter<void>();
  readonly mode = input('horizontal'); // default
  readonly isTopicListView = input(false);
  @Input() isDefaultValue = true;

  ngOnInit(): void {
    if (this.isTopicListView()) {
      this.topicListVisible.change$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(tlv => {
        this.isDefaultValue = !!tlv;
      });
    }
  }

  toggleIt(): void {
    this.toggle.emit();
  }
}
